module.exports = __webpack_public_path__ + "static/smssagan-aa377b348e0e992ee128d039eacc35c6.png";